<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Cotizaciones</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <button v-if="campaign" class="btn base-button btn-neutral btn-sm mt-1" @click="campaign = null">
            Cambiar Campaña
          </button>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div v-if="!campaign" class="row justify-content-center">
        <div class="col-md-6 col-sm-8 col-xs-12 card-wrapper">
          <div class="card mb-4">
            <div class="card-header">
              <h3 class="mb-0">Elija la campaña para listar las cotizaciones</h3>
            </div>
            <div class="card-body">
              <campaign-select v-model="campaign" />
            </div>
          </div>
        </div>
      </div>

      <div v-if="campaign" class="row">
        <div class="col-sm-12">
          <quotations-table :filter-campaign="campaign" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import QuotationsTable from './List/QuotationsTable';
import CampaignSelect from '@/components/ModelSelects/CampaignSelect';
import CurrentCampaignMixin from '@/mixins/currentCampaignMixin';

export default {
  components: {
    RouteBreadCrumb,
    QuotationsTable,
    CampaignSelect,
  },

  mixins: [CurrentCampaignMixin],
};
</script>

<style scoped>
::v-deep .over-header {
  z-index: 99999;
}
</style>
